import { Component, Input } from '@angular/core';

@Component({
  selector: 'dls-page-tabs',
  templateUrl: './page-tabs.component.html',
  styleUrls: ['./page-tabs.component.scss']
})
export class PageTabsComponent {
  @Input() pageTabs: string[];
}
